import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DataMigration = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [syncError, setSyncError] = useState(null);

  const runMigration = async () => {
    console.log('🔄 Starting migration...');
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const token = localStorage.getItem('token');
      console.log('Token found:', token ? 'Yes' : 'No');
      
      if (!token) {
        setError('Not logged in! Please login as superadmin first.');
        setLoading(false);
        return;
      }

      const apiUrl = `${API_URL}/api/admin-migration/populate-student-session-ids`;
      console.log('Calling API:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);

      if (!response.ok) {
        setError(data.detail || 'Migration failed');
        setLoading(false);
        return;
      }

      setResult(data);
      setLoading(false);
      
      if (data.success) {
        alert('✅ Migration Successful!\n\nStudents Updated: ' + data.statistics.students_updated + '\n\nYou can now test Other Fees!');
      } else {
        setError(data.message || 'Migration completed but with issues');
      }

    } catch (err) {
      console.error('Migration error:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  const syncWithdrawnStudents = async () => {
    console.log('🔄 Syncing withdrawn students...');
    setSyncLoading(true);
    setSyncError(null);
    setSyncResult(null);

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setSyncError('Not logged in! Please login first.');
        setSyncLoading(false);
        return;
      }

      const response = await fetch(`${API_URL}/api/data-migration/sync-withdrawn-students`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        setSyncError(data.detail || 'Sync failed');
        setSyncLoading(false);
        return;
      }

      setSyncResult(data);
      setSyncLoading(false);
      
      if (data.success) {
        alert(`✅ Sync Successful!\n\nSynced: ${data.results.synced} students\nAlready Synced: ${data.results.already_synced}\nTotal Withdrawn: ${data.results.total_withdrawn}`);
      }

    } catch (err) {
      console.error('Sync error:', err);
      setSyncError(err.message);
      setSyncLoading(false);
    }
  };

  return (
    <div style={{
      maxWidth: '800px',
      margin: '50px auto',
      padding: '30px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <h1 style={{ color: '#333', marginBottom: '20px' }}>
        🔧 Data Migration Tools
      </h1>

      {/* Sync Withdrawn Students Section */}
      <div style={{
        backgroundColor: '#fff',
        border: '2px solid #dc3545',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px'
      }}>
        <h2 style={{ color: '#dc3545', marginBottom: '15px' }}>
          🚫 Sync Withdrawn Students
        </h2>
        <div style={{
          backgroundColor: '#f8d7da',
          border: '1px solid #f5c6cb',
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '15px'
        }}>
          <strong>📋 What this does:</strong>
          <ul style={{ marginTop: '10px', marginBottom: 0 }}>
            <li>Syncs withdrawn student status to Student Portal</li>
            <li>Allows withdrawn students to see their withdrawal info</li>
            <li>Safe to run multiple times</li>
          </ul>
        </div>

        <button
          onClick={syncWithdrawnStudents}
          disabled={syncLoading}
          style={{
            backgroundColor: syncLoading ? '#ccc' : '#dc3545',
            color: 'white',
            border: 'none',
            padding: '12px 25px',
            fontSize: '14px',
            borderRadius: '5px',
            cursor: syncLoading ? 'not-allowed' : 'pointer'
          }}
        >
          {syncLoading ? '⏳ Syncing...' : '🔄 Sync Withdrawn Students'}
        </button>

        {syncError && (
          <div style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '10px',
            borderRadius: '5px',
            marginTop: '15px'
          }}>
            ❌ Error: {syncError}
          </div>
        )}

        {syncResult && syncResult.success && (
          <div style={{
            backgroundColor: '#d4edda',
            color: '#155724',
            padding: '15px',
            borderRadius: '5px',
            marginTop: '15px'
          }}>
            <strong>✅ Sync Complete!</strong>
            <div style={{ marginTop: '10px' }}>
              <div>📊 Total Withdrawn: {syncResult.results.total_withdrawn}</div>
              <div>✅ Synced: {syncResult.results.synced}</div>
              <div>⏭️ Already Synced: {syncResult.results.already_synced}</div>
              <div>⚠️ Not Found: {syncResult.results.not_found_in_student_users}</div>
            </div>
          </div>
        )}
      </div>

      {/* Student Session Migration Section */}
      <div style={{
        backgroundColor: '#fff',
        border: '2px solid #007bff',
        padding: '20px',
        borderRadius: '8px'
      }}>
        <h2 style={{ color: '#007bff', marginBottom: '15px' }}>
          📚 Student Session Migration
        </h2>
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '15px'
        }}>
        <strong>⚠️ IMPORTANT:</strong>
          <ul>
            <li>You must be logged in as <strong>SUPERADMIN</strong></li>
            <li>This will populate session_id for all students</li>
            <li>Required to fix Other Fees not showing issue</li>
            <li>Safe to run - only adds missing data</li>
          </ul>
        </div>

        <button
          onClick={runMigration}
          disabled={loading}
          style={{
            backgroundColor: loading ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            padding: '12px 25px',
            fontSize: '14px',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? '⏳ Running Migration...' : '🚀 Run Migration Now'}
        </button>

        {error && (
          <div style={{
            backgroundColor: '#f8d7da',
            border: '1px solid #f5c6cb',
            color: '#721c24',
            padding: '15px',
            borderRadius: '5px',
            marginTop: '20px'
          }}>
            <h3>❌ Migration Failed</h3>
            <p><strong>Error:</strong> {error}</p>
          </div>
        )}

        {result && result.success && (
          <div style={{
            backgroundColor: '#d4edda',
            border: '1px solid #c3e6cb',
            color: '#155724',
            padding: '15px',
            borderRadius: '5px',
            marginTop: '20px'
          }}>
            <h3>✅ Migration Completed Successfully!</h3>
            <pre style={{ margin: '10px 0', fontSize: '12px' }}>
              {JSON.stringify(result.statistics, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataMigration;
